import React from 'react';
import './TextArea.scss';
import {TextInput} from '../TextInput';

export class TextArea extends TextInput {

    static defaultProps = {
        autoComplete: 'off',
        rows: 8
    };

    render = () => {
        const {label, message, initialValue, ...rest} = this.props;
        const {value, valid} = this.state;

        return (
            <div className={`form-element ${!valid ? 'form-element-invalid' : ''}`} data-content={!!value} >
                <label className="form-element-label">
                    <span className="form-element-label-text">{label}</span>
                    <textarea {...rest} className="form-element-input" onChange={this.onChange} value={value || initialValue}/>
                </label>
                {message && <span className="form-element-message">{message}</span>}
            </div>
        );
    };
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/components/TextArea/TextArea.jsx